import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

export const useNotyfService = () => {
	if (process.server) return
	const notyf = new Notyf({
		position: {
			x: 'center',
			y: 'top',
		},
		duration: 3000,
	})
	return notyf
}
